import * as React from 'react';
import { clsx } from 'clsx';
import { TColors } from '@cian/ui-kit';

import * as styles from './IconScooter16.css';

interface IIconScooter16Props {
  color?: TColors;
}

// TODO: Заменить на китовую иконку в CD-170476
/* istanbul ignore next */
export const IconScooter16: React.FC<IIconScooter16Props> = ({ color }) => {
  return <div className={clsx(styles['icon'], color === 'white_100' && styles['white'])} />;
};
